import { Component } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiAboutService } from '../Services/api-about.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: false
})
export class FooterComponent {
  appVersion = environment.version;
  year = (new Date()).getFullYear();
  is_vc: boolean = false;
  constructor(private readonly aboutService: ApiAboutService) {
    this.is_vc = this.aboutService.isVotingCenter();
  }
}
